import { Storage } from 'aws-amplify';
import config from './config';

//In order to take advantage of signed URL's (they can be opened, unlike blobs that have to be downloaded)
//we generate the signature when the user actually clicks
//this way we can have a very short expiry time that will not affect the user experience

async function download(access, fileKey, fileName) {
    const accessLevel = (access === "shared" ? "protected" : "private");
    const identityId = (access === "shared" ? config.cognito.SHARED_ID:null);
    const result = await Storage.get(
        fileKey,
        {
            level: accessLevel, // defaults to `public`
            identityId: identityId, // id of another user, if `level: protected`, probably not necessary as protected folder is granted with IAM role
            expires: 60, // validity of the URL, in seconds. defaults to 900 (15 minutes)
            //contentType?: string // set return content type, eg "text/html"
        }
    );
    downloadSigned(result, fileName);
}

//fixme: there might be a cleaner way to handle the clicks than creating a dummy element
function downloadSigned(signedUrl, filename) {
    const a = document.createElement('a');
    a.href = signedUrl;
    a.download = filename;
    a.target = "_blank";
    
    const clickHandler = () => {
      setTimeout(() => {
        URL.revokeObjectURL(signedUrl);
        a.removeEventListener('click', clickHandler);
      }, 150);
    };
    
    a.addEventListener('click', clickHandler, false);
    a.click();
    return a;
}

export {download};